<template lang="pug">
  PageScroll.-width-limiter-(
    v-else
    :data="userPagination"
    @incrementPage="setPage"
    :isLoading="noMorePage"
    width="100%"
  )
    .user-team-list
      template(v-if="true")
        ul.user-team-table(
          :style="{'grid-template-columns': gridLayout}"
        )
          HeaderCell(
            v-for="cell in smartTitleList" :key="cell.id"
          ) {{cell.title}}

        BodyRow(
          v-for="user in userPagination" :key="user.id"
          :gridLayout="gridLayout"
          :user="user"
          :isSmart="true"
          :canSetLeader="false"
          :canChangeTeam="canChangeTeam"
        )

      template(v-else)
        SkeletonRow

</template>

<script>
import HeaderCell from './components/UserTable/components/HeaderCell';
import BodyRow from './components/UserTable/components/BodyRow';
import SkeletonRow from '../Body/components/SkeletonRow';
import { mapState } from 'vuex';

export default {
  components: {
    HeaderCell,
    BodyRow,
    SkeletonRow
  },
  props: {
    userList: {},
    canChangeTeam: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    defaultAvatar: '/lms/img/user-default.jpg',
    page: 0,
    limit: 20
  }),
  computed: {
    ...mapState('teamGroup', {}),
    gridLayout() {
      const result = [];

      this.smartTitleList.forEach(prop => {
        result.push(prop.width || this.defaultWidth);
      });

      return result.join(' ');
    },
    noMorePage() {
      return this.userList.length === this.userPagination;
    },
    userPagination() {
      return this.userList.slice(0, this.page * this.limit);
    },
    smartTitleList() {
      let titleList = [
        {
          id: 0,
          title: 'Контакты',
          width: '1fr'
        },
        {
          id: 1,
          title: 'Telegram',
          width: '1fr'
        }
      ];

      if (this.canChangeTeam) {
        titleList = [
          ...titleList,
          {
            id: 2,
            title: 'Настройки',
            width: '120px'
          }
        ];
      }

      return titleList;
    }
  },
  watch: {},
  mounted() {
    this.setPage();
  },
  methods: {
    setPage() {
      ++this.page;
    }
  }
};
</script>
